let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3PkAh")).then(() => parcelRequire('9Ej9o'));